
module.exports={
create:require('./SafeModule'),
module:require('./SafeModule'),
component:require('./SafeComponent')};